import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const SignUpPage = lazy(() => import('../pages/signup/page'));
const LoginPage = lazy(() => import('../pages/login/page'));
const SupportPage = lazy(() => import('../pages/support/page'));
const DashboardPage = lazy(() => import('../pages/dashboard/page'));
const TermsPage = lazy(() => import('../pages/terms/page'));
const PrivacyPage = lazy(() => import('../pages/privacy/page'));
const MyPage = lazy(() => import('../pages/mypage/page'));
const FaqPage = lazy(() => import('../pages/faq/page'));
const NotFound = lazy(() => import('../pages/NotFound'));
const ContactPage = lazy(() => import('../pages/support/ContactPage'));
const ContactHistoryPage = lazy(() => import('../pages/support/ContactHistoryPage'));
const CreatorPage = lazy(() => import('../pages/creator/page'));
const VerifyPage = lazy(() => import('../pages/verify/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/login',
    element: <LoginPage />,
  },
  {
    path: '/signup',
    element: <SignUpPage />,
  },
  {
    path: '/support',
    element: <SupportPage />,
  },
  {
    path: '/dashboard',
    element: <DashboardPage />,
  },
  {
    path: '/terms',
    element: <TermsPage />,
  },
  {
    path: '/privacy',
    element: <PrivacyPage />,
  },
  {
    path: '/mypage',
    element: <MyPage />,
  },
  {
    path: '/faq',
    element: <FaqPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '/contact/history',
    element: <ContactHistoryPage />,
  },
  {
    path: '/creator/:id',
    element: <CreatorPage />,
  },
  {
    path: '/verify',
    element: <VerifyPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
